import { render, staticRenderFns } from "./main.vue?vue&type=template&id=0d9645ea&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9645ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d9645ea')) {
      api.createRecord('0d9645ea', component.options)
    } else {
      api.reload('0d9645ea', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=0d9645ea&scoped=true", function () {
      api.rerender('0d9645ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/masters/custom-domain/main.vue"
export default component.exports